import React from 'react';
import PropTypes from 'prop-types';

const TabNavigation = ({
  activeTab,
  permList,
  hasApplicantHash,
  onChangeTab,
}) => {
  return (
    <div className='applicants_inner_head inner_head header_tabs'>
      <h2
        className={activeTab === 'profile' ? 'active' : ''}
        onClick={() => onChangeTab('profile')}
      >
        Profile
      </h2>

      {permList.includes('Manage Docs') && (
        <h2
          className={activeTab === 'documents' ? 'active' : ''}
          onClick={() => onChangeTab('documents')}
        >
          Documents
        </h2>
      )}

      <h2
        className={activeTab === 'qualifications' ? 'active' : ''}
        onClick={() => onChangeTab('qualifications')}
      >
        Qualifications
      </h2>

      <h2
        className={activeTab === 'trainings' ? 'active' : ''}
        onClick={() => onChangeTab('trainings')}
      >
        Trainings
      </h2>

      {permList.includes('View/Add Management') && (
        <h2
          className={activeTab === 'management' ? 'active' : ''}
          onClick={() => onChangeTab('management')}
        >
          Management
        </h2>
      )}

      {hasApplicantHash && (
        <h2
          className={activeTab === 'application' ? 'active' : ''}
          onClick={() => onChangeTab('application')}
        >
          Application
        </h2>
      )}
    </div>
  );
};

TabNavigation.propTypes = {
  activeTab: PropTypes.string.isRequired,
  permList: PropTypes.array.isRequired,
  hasApplicantHash: PropTypes.bool,
  onChangeTab: PropTypes.func.isRequired,
};

export default TabNavigation;
